<template>
  <div>
   <h1>Download:</h1>
      <div class="download-list">
        <Button
          v-for="oneData in data"
          :key="oneData"
          class="download-item"
          type="default"
          long
          :loading="downloadingName === oneData"
          :disabled="downloadingName !== ''"
          @click="download(oneData)"
        >
          {{ oneData }}
        </Button>
      </div>
      </div>
</template>

<script>

import { API_URL, } from '@/constants/const.js'
import axios from 'axios';
import { mapGetters } from 'vuex'

import { postJsError,exportFile, blobToString } from '@/util/util.js'
export default {
  name: 'downloadIndex', // 组件名称
  components: {
    
  },
  props: {

  },
  data() {
    return {
      hasAuth: true,
      data: [],
      downloadingName: '',
    }
  },
  computed: {
    ...mapGetters(['getTranslation']),
   
  },
  mounted() {
   
  },
  created() {    
    this.initData();
  },
  methods: {
    initData() {     
      this.getData();
    },
    getData() {
      let url = API_URL["downloadList"];
      let params = {
      }
      axios.get(url, {
        params: params
      })
        .then(res => {
          if (res && res.data && res.data.code == 200) {
            this.data = res.data.data;
          } else if (res && res.data && res.data.code == 3001) {
            this.hasAuth = false;
          } else if (res && res.data && res.data.code && res.data.msg) {
            this.$Message.error(res.data.msg);
          }
        })
        .catch((err) => {
          postJsError(err)
          this.$Message.error(this.getTranslation('c001'));
        })
    },
    async download(oneData){
      let exportUrl = API_URL["downloadFile"];
      try {
        this.downloadingName = oneData;
        const response = await axios.get(exportUrl, {
          responseType: 'blob',
          params: { filename: oneData },
          timeout: 300000,
        });

        if (response.status == 200) {
          const contentType = response.headers['content-type'];
          if (contentType && contentType.includes('application/json')) {
            blobToString(response.data).then(text => {
              let msgData = JSON.parse(text);
              if (msgData.code == 3001) {
                this.hasAuth = false;
                return;
              }
              if (msgData.msg) {
                this.$Message.error(msgData.msg)
              }
            }).catch((err) => {
              postJsError(err)
              this.$Message.error(this.getTranslation('c001'));
            });
          } else {
            exportFile(response)
          }
        } else {
          this.$Message.error(this.getTranslation('c001'));
        }
      } catch (err) {
        postJsError(err)
        this.$Message.error(this.getTranslation('c001'));
      } finally {
        this.downloadingName = '';
      }
    }
  }

}
</script>

<style scoped>
@import url("../../assets/style/list.css");

.download-list {
  max-width: 900px;
}

.download-item {
  margin-bottom: 10px;
  text-align: left;
}
</style>
